import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import SkeletonWrapper from '../../../components/ui/SkeletonWrapper';

const colorMap = {
  purple: {
    bg: 'bg-purple-50',
    iconBg: 'bg-purple-100',
    text: 'text-purple-700',
    border: 'border-purple-200',
    bar: 'bg-purple-400',
  },
  pink: {
    bg: 'bg-pink-50',
    iconBg: 'bg-pink-100',
    text: 'text-pink-700',
    border: 'border-pink-200',
    bar: 'bg-pink-400',
  },
  blue: {
    bg: 'bg-blue-50',
    iconBg: 'bg-blue-100',
    text: 'text-blue-700',
    border: 'border-blue-200',
    bar: 'bg-blue-400',
  },
  green: {
    bg: 'bg-emerald-50',
    iconBg: 'bg-emerald-100',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    bar: 'bg-emerald-400',
  },
  red: {
    bg: 'bg-red-50',
    iconBg: 'bg-red-100',
    text: 'text-red-700',
    border: 'border-red-200',
    bar: 'bg-red-400',
  },
  amber: {
    bg: 'bg-amber-50',
    iconBg: 'bg-amber-100',
    text: 'text-amber-700',
    border: 'border-amber-200',
    bar: 'bg-amber-400',
  },
  indigo: {
    bg: 'bg-indigo-50',
    iconBg: 'bg-indigo-100',
    text: 'text-indigo-700',
    border: 'border-indigo-200',
    bar: 'bg-indigo-400',
  },
};

export default function KPICard({
  label,
  value,
  icon,
  color = 'purple',
  isLoading = false,
  subtitle,
  onClick,
}) {
  const c = colorMap[color] || colorMap.purple;

  return (
    <SkeletonWrapper isLoading={isLoading} width="w-full" height="h-[108px]">
      <motion.div
        whileHover={{ y: -3, boxShadow: '0 12px 40px -12px rgba(0,0,0,0.12)' }}
        onClick={onClick}
        className={`relative overflow-hidden bg-surface border ${c.border} rounded-xl p-5 transition-all duration-300 ${onClick ? 'cursor-pointer' : ''}`}
      >
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-[11px] font-semibold text-text-secondary uppercase tracking-wider">
              {label}
            </p>
            <p className="text-2xl font-bold text-text-primary mt-1">
              {value?.toLocaleString() ?? value}
            </p>
            {subtitle && <p className="text-[11px] text-text-secondary mt-0.5">{subtitle}</p>}
          </div>
          <div className={`${c.iconBg} rounded-lg p-2.5 shrink-0 ml-3`}>
            <Icon name={icon} size={20} className={c.text} />
          </div>
        </div>
        <div className={`absolute bottom-0 left-0 right-0 h-[3px] ${c.bar} opacity-60`} />
      </motion.div>
    </SkeletonWrapper>
  );
}
